var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bg-box bg-box-'+_vm.type},[(_vm.icon)?_c('div',{staticClass:"bg-box-icon"},[_c('i',{class:_vm.icon})]):_vm._e(),_c('div',[(_vm.title)?_c('div',{staticClass:"bg-box-title"},[_vm._v(_vm._s(_vm.title)+"\n      "),_vm._t("header-left"),_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"bg-box-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }